import MainGoal from "../../components/Forms/MainGoal";
import BasicCard from "../BasicCard";
import MainLayout from "../MainLayout";
import Dummylayout from "../Dummylayout";
import SubGoal  from "../../components/Forms/SubGoal";

function SubGoalMain() {
    return (
        <>
        {/* <MainLayout/> */}
           <div> <Dummylayout/></div>
    
<div className="mx-5 pl-5">
            <BasicCard>
              <SubGoal/>
                
            </BasicCard>
            </div>
        </>
    )
}
export default SubGoalMain;